// extracted by mini-css-extract-plugin
export default {"container":"tN-z","topReviewHeading":"uN-z","criticalReview":"vN-z","favorableReview":"wN-z","vsSeparator":"xN-z"};